import { ProductFormProvider } from "../../contexts/ProductFormContext";
import { UpdateProductContent } from "./UpdateProductContent";

type PropTypes = {
  onBack: () => void;
  selectedId: string;
};
const UpdateProduct = ({ onBack, selectedId }: PropTypes) => {
  return (
    <ProductFormProvider>
      <UpdateProductContent onBack={onBack} selectedId={selectedId} />
    </ProductFormProvider>
  );
};

export default UpdateProduct;
